import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { IGHGridColumn } from "@gtmhub/shared/components/grid/grid.component";
import { determineAccessType } from "@gtmhub/shared/components/simple-permissions/simple-permissions.utils";
import { OkrViewAccessType } from "@webapp/okrs/okr-views/models/okr-views.models";
import { IAccess } from "@webapp/sessions/models/sessions.model";
import { ShareableFilter } from "@webapp/shared/unified-filters/models/shareable-filters.models";

@Component({
  selector: "okr-views-grid-cell",
  templateUrl: "./okr-views-grid-cell.component.html",
  styleUrls: ["./okr-views-grid-cell.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OkrViewsGridCellComponent {
  @Input() public item: ShareableFilter;
  @Input() public column: IGHGridColumn;

  public mapAccessObjectToSimplePermissions = (accessObject: IAccess): OkrViewAccessType => {
    return determineAccessType(accessObject);
  };
}
